import imageUrlBuilder from "@sanity/image-url";
import type { SanityImageSource } from "@sanity/image-url";

import { sanityClient } from "./client";

const builder = sanityClient ? imageUrlBuilder(sanityClient) : null;

// Default every Sanity image request through the CDN with automatic format
// negotiation (serves webp/avif when the browser supports it) and a sensible
// quality target. Individual callers can still override by chaining .quality()
// or .format() after urlForImage().
export const urlForImage = (source?: SanityImageSource) => {
  if (!builder || !source) return null;
  return builder.image(source).auto("format").quality(78);
};
